import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createCondicaoPagamentoModel } from '../utils/condicoesPagamentoUtils';

// idb store name
const storeName = 'condicoesPagamento';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'condicaopagamento';
// const sqlCondicaoPagamento = 9;
// const sqlCondicaoPagamentoParcela = 10;

export const condicaoPagamentoService = {
  getCondicoesPagamento,
  getCondicoesPagamentoAPI,
  getCondicaoPagamento,
  addCondicaoPagamento,
  addCondicoesPagamento,
  updateCondicaoPagamento,
  compareAndUpdateCondicoesPagamento
};

function getCondicoesPagamento() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBCondicoesPagamento();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getCondicoesPagamentoAPI();
  return getIndexedDBCondicoesPagamento();
}

async function getCondicoesPagamentoAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_condicao_pagamento",
      "condicao_pagamento",
      "parcelas"
    ],
    filtros: [
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const condicoesPagamentoApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateCondicoesPagamento(condicoesPagamentoApi);
  await removeInexistentes(condicoesPagamentoApi);
  return condicoesPagamentoApi;
}

// function getCondicaoPagamentoParcelasAPI(idCondicaoPagamento) {
//   return apiRequest.get(`${baseURL}/sql/${sqlCondicaoPagamentoParcela}?:idCondicaoPagamento=${idCondicaoPagamento}`);
// }


function getIndexedDBCondicoesPagamento() {
  return idbService.getAll(storeName);
}

function getCondicaoPagamento(id) {
  return idbService.getById(storeName, id);
}

async function compareAndUpdateCondicoesPagamento(condicoesPagamento) {
  if (condicoesPagamento && condicoesPagamento.length) {
    for (const condicaoPagamento of condicoesPagamento) {
      const savedCondicaoPagamento = await getCondicaoPagamento(condicaoPagamento.id_condicao_pagamento);
  
      if (!savedCondicaoPagamento) {
        condicaoPagamento.versao_imp = 1;
        await addCondicaoPagamento(condicaoPagamento);
      } else {
        condicaoPagamento.versao_imp = savedCondicaoPagamento.versao_imp ? savedCondicaoPagamento.versao_imp + 1 : 1;
        await updateCondicaoPagamento(condicaoPagamento);
      }
    }
  } else {
    // Limpa os registros do store condicaoPagamentos
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(condicoesPagamentoApi) {
  if (condicoesPagamentoApi && condicoesPagamentoApi.length) {
    const idsCondicoesPagamentoApi = condicoesPagamentoApi.map(condicaoPagamentoApi => condicaoPagamentoApi.id_condicao_pagamento);
    const condicoesPagamentoLocal = await idbService.getAll(storeName);
    const condicoesPagamentoInexistentes = condicoesPagamentoLocal.filter(condicaoPagamentoLocal => !idsCondicoesPagamentoApi.includes(condicaoPagamentoLocal.id_condicao_pagamento));
    if (condicoesPagamentoInexistentes && condicoesPagamentoInexistentes.length) {
      for (const condicaoPagamento of condicoesPagamentoInexistentes) {
        await idbService.deleteFromStore(storeName, condicaoPagamento.id_condicao_pagamento);
      }
    }
  } else {
    return;
  }
}

async function addCondicaoPagamento(condicaoPagamento) {
  const parsedCondicaoPagamento = createCondicaoPagamentoModel(condicaoPagamento);
  return idbService.addToStore(storeName, parsedCondicaoPagamento);
}

async function addCondicoesPagamento(condicoesPagamento = []) {
  const parsedCondicoesPagamento = condicoesPagamento.map(condicaoPagamento => createCondicaoPagamentoModel(condicaoPagamento));
  return idbService.addMultipleToStore(storeName, parsedCondicoesPagamento);
}

async function updateCondicaoPagamento(condicaoPagamento) {
  const parsedCondicaoPagamento = createCondicaoPagamentoModel(condicaoPagamento);
  await idbService.updateItem(storeName, parsedCondicaoPagamento);
}